import { render, staticRenderFns } from "./CompanyQuestionnaireCard.vue?vue&type=template&id=2db48c34&"
import script from "./CompanyQuestionnaireCard.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionnaireCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports